// Central Role Registry
// Import all role configurations and data

// UX Designer
import * as uxDesigner from './ux-designer/index.js';

// Frontend Developer  
import * as frontend from './frontend/index.js';

// Backend Developer
import * as backend from './backend/index.js';

// Fullstack Developer
import * as fullstack from './fullstack/index.js';

// Mobile Developer
import * as mobile from './mobile/index.js';

// DevOps Engineer
import * as devops from './devops/index.js';

// QA Engineer
import * as qa from './qa-engineer/index.js';

// Product Manager
import * as productManager from './product-manager/index.js';

// Product Owner
import * as productOwner from './product-owner/index.js';

// UX Researcher
import * as uxResearcher from './ux-researcher/index.js';

// Content Designer
import * as contentDesigner from './content-designer/index.js';

// Product Designer
import * as productDesigner from './product-designer/index.js';

// UI Designer
import * as uiDesigner from './ui-designer/index.js';

// Role Registry - Maps role IDs to their complete configuration
export const roleRegistry = {
  'ux-designer': {
    config: uxDesigner.uxDesignerConfig,
    resources: uxDesigner.uxDesignerResources,
    documentation: uxDesigner.uxDesignerDocumentation,
    teamDirectory: uxDesigner.uxDesignerTeamDirectory,
    workEnvironment: uxDesigner.uxDesignerWorkEnvironment,
    essentialTools: uxDesigner.uxDesignerEssentialTools,
    collaborationSetup: uxDesigner.uxDesignerCollaborationSetup,
    platformAccess: uxDesigner.uxDesignerPlatformAccess,
    securitySetup: uxDesigner.uxDesignerSecuritySetup,
    teamWorkflow: uxDesigner.uxDesignerTeamWorkflow
  },
  'frontend': {
    config: frontend.config,
    resources: frontend.resources,
    documentation: frontend.documentation,
    teamDirectory: frontend.teamDirectory,
    workEnvironment: frontend.workEnvironment,
    essentialTools: frontend.essentialTools,
    collaborationSetup: frontend.collaborationSetup,
    platformAccess: frontend.platformAccess,
    securitySetup: frontend.securitySetup,
    teamWorkflow: frontend.teamWorkflow
  },
  'backend': {
    config: backend.config,
    resources: backend.resources,
    documentation: backend.documentation,
    teamDirectory: backend.teamDirectory,
    workEnvironment: backend.workEnvironment,
    essentialTools: backend.essentialTools,
    collaborationSetup: backend.collaborationSetup,
    platformAccess: backend.platformAccess,
    securitySetup: backend.securitySetup,
    teamWorkflow: backend.teamWorkflow
  },
  'fullstack': {
    config: fullstack.config,
    resources: fullstack.resources,
    documentation: fullstack.documentation,
    teamDirectory: fullstack.teamDirectory,
    workEnvironment: fullstack.workEnvironment,
    essentialTools: fullstack.essentialTools,
    collaborationSetup: fullstack.collaborationSetup,
    platformAccess: fullstack.platformAccess,
    securitySetup: fullstack.securitySetup,
    teamWorkflow: fullstack.teamWorkflow
  },
  'mobile': {
    config: mobile.config,
    resources: mobile.resources,
    documentation: mobile.documentation,
    teamDirectory: mobile.teamDirectory,
    workEnvironment: mobile.workEnvironment,
    essentialTools: mobile.essentialTools,
    collaborationSetup: mobile.collaborationSetup,
    platformAccess: mobile.platformAccess,
    securitySetup: mobile.securitySetup,
    teamWorkflow: mobile.teamWorkflow
  },
  'devops': {
    config: devops.config,
    resources: devops.resources,
    documentation: devops.documentation,
    teamDirectory: devops.teamDirectory,
    workEnvironment: devops.workEnvironment,
    essentialTools: devops.essentialTools,
    collaborationSetup: devops.collaborationSetup,
    platformAccess: devops.platformAccess,
    securitySetup: devops.securitySetup,
    teamWorkflow: devops.teamWorkflow
  },
  'qa': {
    config: qa.config,
    resources: qa.resources,
    documentation: qa.documentation,
    teamDirectory: qa.teamDirectory,
    workEnvironment: qa.workEnvironment,
    essentialTools: qa.essentialTools,
    collaborationSetup: qa.collaborationSetup,
    platformAccess: qa.platformAccess,
    securitySetup: qa.securitySetup,
    teamWorkflow: qa.teamWorkflow
  },
  'product-manager': {
    config: productManager.config,
    resources: productManager.resources,
    documentation: productManager.documentation,
    teamDirectory: productManager.teamDirectory,
    workEnvironment: productManager.workEnvironment,
    essentialTools: productManager.essentialTools,
    collaborationSetup: productManager.collaborationSetup,
    platformAccess: productManager.platformAccess,
    securitySetup: productManager.securitySetup,
    teamWorkflow: productManager.teamWorkflow
  },
  'product-owner': {
    config: productOwner.config,
    resources: productOwner.resources,
    documentation: productOwner.documentation,
    teamDirectory: productOwner.teamDirectory,
    workEnvironment: productOwner.workEnvironment,
    essentialTools: productOwner.essentialTools,
    collaborationSetup: productOwner.collaborationSetup,
    platformAccess: productOwner.platformAccess,
    securitySetup: productOwner.securitySetup,
    teamWorkflow: productOwner.teamWorkflow
  },
  'ux-researcher': {
    config: uxResearcher.config,
    resources: uxResearcher.resources,
    documentation: uxResearcher.documentation,
    teamDirectory: uxResearcher.teamDirectory,
    workEnvironment: uxResearcher.workEnvironment,
    essentialTools: uxResearcher.essentialTools,
    collaborationSetup: uxResearcher.collaborationSetup,
    platformAccess: uxResearcher.platformAccess,
    securitySetup: uxResearcher.securitySetup,
    teamWorkflow: uxResearcher.teamWorkflow
  },
  'content-designer': {
    config: contentDesigner.config,
    resources: contentDesigner.resources,
    documentation: contentDesigner.documentation,
    teamDirectory: contentDesigner.teamDirectory,
    workEnvironment: contentDesigner.workEnvironment,
    essentialTools: contentDesigner.essentialTools,
    collaborationSetup: contentDesigner.collaborationSetup,
    platformAccess: contentDesigner.platformAccess,
    securitySetup: contentDesigner.securitySetup,
    teamWorkflow: contentDesigner.teamWorkflow
  },
  'product-designer': {
    config: productDesigner.config,
    resources: productDesigner.resources,
    documentation: productDesigner.documentation,
    teamDirectory: productDesigner.teamDirectory,
    workEnvironment: productDesigner.workEnvironment,
    essentialTools: productDesigner.essentialTools,
    collaborationSetup: productDesigner.collaborationSetup,
    platformAccess: productDesigner.platformAccess,
    securitySetup: productDesigner.securitySetup,
    teamWorkflow: productDesigner.teamWorkflow
  },
  'ui-designer': {
    config: uiDesigner.config,
    resources: uiDesigner.resources,
    documentation: uiDesigner.documentation,
    teamDirectory: uiDesigner.teamDirectory,
    workEnvironment: uiDesigner.workEnvironment,
    essentialTools: uiDesigner.essentialTools,
    collaborationSetup: uiDesigner.collaborationSetup,
    platformAccess: uiDesigner.platformAccess,
    securitySetup: uiDesigner.securitySetup,
    teamWorkflow: uiDesigner.teamWorkflow
  }
};

// Helper functions for accessing role data
export const getRoleConfig = (roleId) => {
  return roleRegistry[roleId]?.config || null;
};

export const getRoleSection = (roleId, section) => {
  return roleRegistry[roleId]?.[section] || null;
};

export const getAllRoles = () => {
  return Object.keys(roleRegistry);
};

export const getRolesByDepartment = (department) => {
  return Object.entries(roleRegistry)
    .filter(([, role]) => role.config?.department === department)
    .map(([roleId]) => roleId);
};

// Legacy compatibility - export role configs in old format
export const roleConfigs = Object.fromEntries(
  Object.entries(roleRegistry).map(([roleId, role]) => [
    roleId,
    {
      id: role.config?.id,
      icon: role.config?.icon,
      color: role.config?.color,
      title: role.config?.title,
      description: role.config?.description
    }
  ])
);
